// extracted by mini-css-extract-plugin
export default {"card-content":"components-parity-insight-historical-block-module__card-content"};